import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-680d0204"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]

import RightArrowIcon from '@/assets/svg/RightArrowIcon.vue'

interface Props {
  label?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ArrowButton',
  props: {
    label: null
  },
  setup(__props: any) {

const props = __props as {
  label?: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "arrow-button rounded-full w-9 h-9 flex justify-center items-center bg-poppy drop-shadow cursor-pointer",
    "aria-label": props.label
  }, [
    _createVNode(RightArrowIcon)
  ], 8, _hoisted_1))
}
}

})